// import { bootstrapApplication } from '@angular/platform-browser';
// import { RouteReuseStrategy, provideRouter, withPreloading, PreloadAllModules } from '@angular/router';
// import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';
// import { provideHttpClient,withInterceptors } from '@angular/common/http';
// import { routes } from './app/app.routes';
// import { AppComponent } from './app/app.component';
// import { authInterceptor } from './app/interceptors/auth.interceptor'; // Ajusta la ruta4

// bootstrapApplication(AppComponent, {
//   providers: [
//     { provide: RouteReuseStrategy, useClass: IonicRouteStrategy},
//     provideHttpClient(withInterceptors([authInterceptor])), // <-- AQUÍ SE AGREGA
    
//     provideIonicAngular(),
//     provideRouter(routes, withPreloading(PreloadAllModules)),
//     provideHttpClient(),
//   ],
// });

import { bootstrapApplication } from '@angular/platform-browser';
import { RouteReuseStrategy, provideRouter, withPreloading, PreloadAllModules } from '@angular/router';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';
import { provideHttpClient, withInterceptors, HttpClient } from '@angular/common/http';
import { inject, isDevMode } from '@angular/core';
import { Observable } from 'rxjs';

import { routes } from './app/app.routes';
import { AppComponent } from './app/app.component';
import { authInterceptor } from './app/interceptors/auth.interceptor';

import { provideTranslateService, TranslateLoader } from '@ngx-translate/core';
import { provideServiceWorker } from '@angular/service-worker';
import { defineCustomElements } from '@ionic/pwa-elements/loader';

defineCustomElements(window);
// Loader personalizado compatible con Angular Standalone y HttpClient
export class CustomTranslateHttpLoader implements TranslateLoader {
  private http = inject(HttpClient);

  getTranslation(lang: string): Observable<any> {
    return this.http.get(`./assets/i18n/${lang}.json`);
  }
}

bootstrapApplication(AppComponent, {
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideIonicAngular(),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    
    provideHttpClient(withInterceptors([authInterceptor])),
    
    provideTranslateService({
      fallbackLang: 'ES',
      loader: {
        provide: TranslateLoader,
        useClass: CustomTranslateHttpLoader // 👈 Carga dinámica directa sin factorías complejas
      }
    }), provideServiceWorker('ngsw-worker.js', {
            enabled: !isDevMode(),
            registrationStrategy: 'registerWhenStable:30000'
          })
  ],
});